'use client';

import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast border border-[var(--line)] bg-[var(--surface)] text-[var(--text)] shadow-[0_18px_44px_-14px_rgba(19,25,26,0.28),0_4px_12px_-4px_rgba(19,25,26,0.12)] dark:shadow-[0_24px_56px_-16px_rgba(0,0,0,0.7),0_6px_16px_-4px_rgba(0,0,0,0.5)] rounded-none font-sans',
          description: 'group-[.toast]:text-[var(--text-muted)]',
          actionButton:
            'group-[.toast]:bg-[var(--accent)] group-[.toast]:text-[var(--accent-fg)] group-[.toast]:rounded-none',
          cancelButton:
            'group-[.toast]:bg-[var(--surface-2)] group-[.toast]:text-[var(--text-muted)] group-[.toast]:rounded-none',
          success: 'group-[.toaster]:text-[var(--rye-green)]',
          error: 'group-[.toaster]:text-[var(--rye-red)]',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
